/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var RadioMixin = require('ES/utils/RadioMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var AuthedUserSession = require('../../../utils/AuthedUserSession');

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {sid: -1, has_hubspot_connected: null, is_reading: false, read_error_msg: null};
  },
  componentWillReceiveProps: function (props) {
    this.__loadForSid(props.selected_sid);
  },
  componentDidMount: function () {
    this.__loadForSid(this.props.selected_sid);
  },
  componentWillMount: function () {
    var self = this;
    self.radio = {
      read_Thirdpartyconnection_Hubspot_config: function (sid) {
        if (self.state.sid == sid) {
          self.setState({has_hubspot_connected: null, is_reading: true, read_error_msg: null});
        }
      },
      read_Thirdpartyconnection_Hubspot_config_succeeded: function (sid, data) {
        if (self.state.sid == sid) {
          self.setState({has_hubspot_connected: !_.isEmpty(data), is_reading: false, read_error_msg: null});
        }
      },
      read_Thirdpartyconnection_Hubspot_config_failed: function (sid, message) {
        if (self.state.sid == sid) {
          self.setState({has_hubspot_connected: null, is_reading: false, read_error_msg: 'Failed to read your Hubspot connector settings: ' + message});
        }
      },
      remove_Thirdpartyconnection_Hubspot_config: function (sid) {
        if (self.state.sid == sid) {
          self.setState({has_hubspot_connected: null, is_reading: true, read_error_msg: null});
        }
      }

    };
  },
  __loadForSid: function (sid) {
    if (sid != this.state.sid) {
      this.setState({sid: sid, has_hubspot_connected: null, is_reading: false, read_error_msg: null}, function () {
        radio('read_Thirdpartyconnection_Hubspot_config').broadcast(sid);
      });
    }
  },
  __removeHubspotConfig: function (sid) {

    let self = this;
    if (sid == this.state.sid) {
      radio('remove_Thirdpartyconnection_Hubspot_config').broadcast(sid,
        function (sid, data) {
          self.setState({has_hubspot_connected: false, is_reading: false, read_error_msg: null});
        },
        function (sid, data) {
          self.setState({has_hubspot_connected: true, is_reading: false, read_error_msg: _.get(data, 'message', 'Unknown error.')});
        });
    }
  },
  render: function () {
    let Displaylists = this.props.Displaylists;
    let speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
      return spkr.sid == this.state.sid;
    }, this);

    let connect_url = '/balboa3/thirdpartyconnection/confighubspot/' + this.state.sid + '/start_oauth?' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);

    return dd.div(null,
      LoadingWrap({is_loading: this.state.is_reading, glass: true},
        dd.h3(null, 'HubSpot connector for ',
          dd.span({className: 'nametag'},
            AuthedUserSession.MY_USERNAME),
          ' + ',
          dd.span({className: 'nametag'},
            speaker ? speaker.name_full : '')
        ),
        dd.p({className: 'text-muted'},
          'NOTE: The settings for this connector is for your eSpeakers account for this speaker specifically. ',
          'Other users for this speaker account will need to configure this individually with their own HubSpot login.'
        ),
        ErrorAlert({message: this.state.read_error_msg}),
        this.state.has_hubspot_connected === true ? dd.div(null,
          dd.div({className: 'alert alert-success'},
            'You are connected to HubSpot!'
          ),
          dd.p({},
            dd.a({href: connect_url}, 'Click here to CHANGE the HubSpot account to which you are connected.')
          ),
          dd.p({},
            dd.a({onClick: this.__removeHubspotConfig.bind(this, this.state.sid)}, 'Click here to DISCONNECT your HubSpot account.')
          )
        ) : dd.div(null,
          dd.p(null,
            'The link below will take you to Hubspot\'s site, where you can sign in with your HubSpot credentials.'
          ),
          dd.p(null,
            'HubSpot will ask if it\'s OK for eSpeakers to access your contacts, and you should ', dd.b(null, 'choose ALLOW ACCESS.')
          ),
          dd.a({href: connect_url, className: 'btn btn-primary'},
            'Connect to your HubSpot account'
          ),
          dd.br(),
          dd.br()
        )
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/Hubspot.js